import React from "react";
import { useRecoilState } from "recoil";
import { showMenu } from "@atoms";
import "./style.css";

const MenuOverlay = ({ isVisible }) => {
  const [, setMenuShow] = useRecoilState(showMenu);
  
  const closeByOverlayClick = (e) => {
    if (e.target.id === "menuOverlay") {
      setMenuShow(false);
    }
  };

  return (
    <div
      onClick={(e) => closeByOverlayClick(e)}
      id="menuOverlay"
      className={`menu_overlay ${isVisible ? '' : 'hide'}`}
    ></div>
  );
};

export default MenuOverlay;